import { getPermissionsList } from "./getPermission";
let permissionList = null;
const _getPermissions = async () => {
  let token = await getPermissionsList();
  permissionList = token?.permissions;
};
_getPermissions();
export const hasPermission = (userPermissions, itemPermissions) => {
  let permissionsArray = userPermissions?.map((item) => {
    return item?.name;
  });
  return permissionsArray?.some((item) => itemPermissions?.includes(item));
};
export const checkPermission = (permission) => {
  return hasPermission(permissionList, [permission]);
};

async function parseToken(token) {
  try {
    return await JSON.parse(window.atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

const errorLog = (msg) => console.log(msg);

export { parseToken, errorLog };
